var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-container",style:({ '--lineWidth': (_vm.lineWidth + "px"), '--right': ("-" + _vm.lineWidth + "px") })},_vm._l((_vm.value),function(item,index){return _c('div',{key:index,class:[
      'step-item',
      { 'step-item-next': index !== _vm.value.length - 1 },
      { 'step-item-active': index <= _vm.current } ],style:({
      marginRight: index !== _vm.value.length - 1 ? (_vm.lineWidth + "px") : '',
    }),attrs:{"data-lineWidth":(_vm.lineWidth + "px")}},[_c('span',{staticClass:"step-item-no"},[_vm._v(_vm._s(index + 1))]),_vm._v(_vm._s(item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }